var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 26,
    viewBox: "0 0 39 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.1429V14.8571H31.6505V18.5714H35.3252V14.8571H39V11.1429H35.3252V7.42857H31.6505V11.1429H0ZM27.9757 3.71429H31.6505V7.42857H27.9757V3.71429ZM27.9757 3.71429H24.301V0H27.9757V3.71429ZM27.9757 22.2857H31.6505V18.5714H27.9757V22.2857ZM27.9757 22.2857H24.301V26H27.9757V22.2857Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.dbc1409baeb5e03d3d06a9dbfb466eb1.svg";
export { ForwardRef as ReactComponent };